export default function RankingSection() {
  const rankings = [
    {
      rank: 1,
      title: '时空守卫者：终局之战',
      type: '动作 / 科幻',
      desc: '暑期档票房冠军，视觉特效震撼，剧情紧凑刺激。',
      img: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20action%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20hero%20silhouette%20against%20cosmic%20background%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20dark%20atmospheric%20composition%2C%20no%20text&width=200&height=280&seq=rank-1-scifi-action&orientation=portrait',
      badge: '热映中',
    },
    {
      rank: 2,
      title: '暗夜追踪',
      type: '悬疑 / 犯罪',
      desc: '国产悬疑力作，豆瓣评分8.7，剧情反转不断。',
      img: 'https://readdy.ai/api/search-image?query=Mystery%20crime%20thriller%20movie%20poster%20style%20with%20shadowy%20figure%2C%20warm%20streetlamp%20glow%2C%20dark%20rainy%20atmosphere%2C%20cinematic%20composition%2C%20deep%20amber%20and%20dark%20tones%2C%20no%20text&width=200&height=280&seq=rank-2-mystery&orientation=portrait',
      badge: '高分推荐',
    },
    {
      rank: 3,
      title: '长安十二时辰之番外篇',
      type: '古装 / 剧情',
      desc: '大唐盛世风云再起，制作精良的古装大剧。',
      img: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20movie%20poster%20style%20with%20ancient%20palace%20elements%2C%20warm%20lantern%20light%2C%20elegant%20Tang%20dynasty%20costume%2C%20golden%20and%20crimson%20tones%2C%20dark%20rich%20background%2C%20no%20text&width=200&height=280&seq=rank-3-historical&orientation=portrait',
      badge: '热播中',
    },
    {
      rank: 4,
      title: '恋爱法则',
      type: '爱情 / 喜剧',
      desc: '轻松治愈的都市爱情喜剧，这个夏天最甜的剧。',
      img: 'https://readdy.ai/api/search-image?query=Romantic%20comedy%20movie%20poster%20style%20with%20warm%20sunset%20lighting%2C%20couple%20silhouette%2C%20soft%20dreamy%20atmosphere%2C%20golden%20and%20pink%20warm%20tones%2C%20dark%20background%2C%20no%20text&width=200&height=280&seq=rank-4-romance&orientation=portrait',
      badge: '新上线',
    },
    {
      rank: 5,
      title: '极地求生',
      type: '纪录片 / 自然',
      desc: 'BBC年度自然纪录片大作，画面美到窒息。',
      img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20movie%20poster%20style%20with%20arctic%20landscape%2C%20polar%20bear%20silhouette%2C%20golden%20aurora%20sky%2C%20cinematic%20wide%20composition%2C%20cool%20and%20warm%20contrast%20tones%2C%20dark%20background%2C%20no%20text&width=200&height=280&seq=rank-5-documentary&orientation=portrait',
      badge: '口碑佳作',
    },
  ];

  return (
    <section id="ranking" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            热门榜单
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            本周最受欢迎的影视作品TOP5，数据实时更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {rankings.map((item, i) => (
            <article
              key={i}
              className="group flex items-center gap-4 md:gap-5 bg-background-100 rounded-xl p-4 md:p-5 border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              {/* Rank number */}
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center">
                {item.rank === 1 ? (
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-accent-500 rounded-xl">
                    <i className="ri-vip-crown-line text-background-50 text-lg"></i>
                  </div>
                ) : item.rank === 2 ? (
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-secondary-400 rounded-xl">
                    <span className="text-lg md:text-xl font-bold font-heading text-background-50">{item.rank}</span>
                  </div>
                ) : item.rank === 3 ? (
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-secondary-300 rounded-xl">
                    <span className="text-lg md:text-xl font-bold font-heading text-background-50">{item.rank}</span>
                  </div>
                ) : (
                  <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center bg-background-200 rounded-xl">
                    <span className="text-lg md:text-xl font-bold font-heading text-foreground-500">{item.rank}</span>
                  </div>
                )}
              </div>

              {/* Poster */}
              <div className="flex-shrink-0 w-12 h-16 md:w-14 md:h-20 rounded-lg overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                    {item.title}
                  </h3>
                  <span className="flex-shrink-0 px-2 py-0.5 text-xs font-medium bg-primary-100 text-primary-600 rounded-full whitespace-nowrap">
                    {item.badge}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mb-1">{item.type}</p>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-1 hidden sm:block">
                  {item.desc}
                </p>
              </div>

              {/* Arrow */}
              <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center text-foreground-400 group-hover:text-primary-500 transition-colors">
                <i className="ri-arrow-right-s-line"></i>
              </div>
            </article>
          ))}
        </div>

        <div className="text-center mt-6">
          <p className="text-xs text-foreground-500">
            榜单数据基于近7日用户浏览量和评分综合计算，每周一更新
          </p>
        </div>
      </div>
    </section>
  );
}